import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { Icon } from 'src/common/components/templateDetails/TemplateDetails.styled';
import Grid from '@material-ui/core/Grid';

export const HeaderTextContainer1 = styled(Grid)`
    font-size: 18px;
    text-align: left;
    font-family: 'AvenirNextWorld Demi';
    color: #130e4a;
    opacity: 1; 
`;

export const HeaderTextContainer2 = styled(Grid)`
    font-size: 13px;
    font-family: 'AvenirNextWorld Regular';
    color: #202124;
`;


export const HeaderTextContainer3 = styled(Grid)`
    font-size: 14px;
    margin-left: 25px;
    text-align: left;
    padding-top: 14px;
    font-family: 'AvenirNextWorld Demi';
    opacity: 1;
   
`;

export const HeaderTextContainer4 = styled(Grid)`
    font-family: 'AvenirNextWorld Demi';
    font-size: 14px;
    color: #202124;
    padding-bottom: 8px;
    ${media.mobileDevice`
    padding-top: 0px;
    margin-bottom:0px;
    `}
`;

export const Container = styled(Grid)`
`;

export const ContainerGrid = styled(Grid)`
    ${media.smalDevice`
    margin-right: ${(props) => props.ipadMarginRight};
    `}
`;

export const Container1 = styled(Grid)`
`;

export const ContainerGrid1 = styled(Grid)`
`;

export const Container2 = styled(Grid)`
    ${media.mobileDevice`
    background-color: white; 
    `}
`;

export const From = styled(Grid)`
    font-family: 'AvenirNextWorld Regular';
    font-size: 14px;
    margin-bottom:10px;  
`;

export const To = styled(Grid)`
    font-family: 'AvenirNextWorld Regular';
    font-size: 14px;
    margin-bottom:10px;
`;

export const Line = styled(Grid)`
    margin-top: 25px;
    border: 1px solid #707070;
    background-color: #707070;
    opacity: 0.3;
    ${media.mobileDevice`
    margin-top: 0px;
    `}
`;


export const CloseIcon = styled(Icon)`  
     margin: 0 0 0 auto;
    ${media.smalDevice`
    margin-left: ${(props) => props.ipadMarginLeft};
    `}
`;

export const ValidContainer= styled(Grid)`
margin-top: 15px;
`;

export const BottomNavigationButtonContainer = styled.div`
    display: flex;
    width: 100%;
    max-width: 1096px;
    flex-direction: row;
    right: 0;
    background-color: white;
    justify-content: ${(props) =>
        props.justifyContent ? props.justifyContent : 'flex-end'};
    padding: ${(props) => (props.padding ? props.padding : '0px 0px 0px 0px')};
    @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
        /* For portrait layouts only */
        justify-content: ${({ smallJustifyContent }) =>
            smallJustifyContent ? smallJustifyContent : 'flex-end'};
        padding-right: 0px;
        padding: ${(props) => (props.mbPadding ? props.mbPadding : '0px')};
    }
    ${media.smalDevice`    
        background-color: #FFFFFF;
          padding: ${(props) =>
              props.ipadPadding ? props.ipadPadding : '0px'};`}
    ${media.mobileDevice` 
        
         background-color: #FFFFFF;
           padding: ${(props) => (props.mbPadding ? props.mbPadding : '0px')};`}

    button{
        ${media.mobileDevice`
            /* width: 80px; */
            padding: 0 15px;
            margin: 10px 5px;
        `}
        @media screen and (max-device-width: 360px) {
                width: 80px;
                padding: 0 15px;
            }
    }
`;
export const TextBold = styled.div`
    text-align: left;
    font-family: AvenirNextWorld demi;
    letter-spacing: -0.12px;
    display: flex;
    align-self: center;
`;

export const PopupContainer = styled.div`
    display: block;
    width: 100%;
    height: 100%;
    overflow: hidden;
`;

export const Username = styled.div`
    margin: 3px 16px 0 9px;
    font-family: 'AvenirNextWorld Demi';
    font-size: 16px;
`;


export const Name = styled.div`
    margin: 0 6px 0 0;
    font-family: 'AvenirNextWorld Regular';
    font-size: 16px;
    color: #202124;
`;

export const Designation = styled.div`
    margin: auto;
    font-family: 'AvenirNextWorld Regular';
    font-size: 14px;
    color: #202124;
    opacity: 0.7;
    ${media.mobileDevice`
        margin: 0 0 0 6px;`};
`;

export const By = styled.div`
    margin: 20px 0 1px 0px;
    font-family: 'AvenirNextWorld Demi';
    font-size: 14px;
    color: #202124;
`;

export const User = styled.div`
    display: inline-flex;
    margin: auto;
    ${media.mobileDevice`
display:inline-block`}
`;


export const UpdateProxyPopupContainer = styled.div`
    ${media.mobileDevice`
        overflow-y: scroll;
        height: 370px;
    `}
`;

export const AddProxyPopupMainContainer = styled.div`
   #popUpContent{
        ${media.mobileDevice`
            top: -40px;
        `}
    }
`;